import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { defaultLocale, locales } from '@/constants/locale';

// Import all translation files
import enTranslation from '@/locales/en/translation.json';
import huTranslation from '@/locales/hu/translation.json';
import deTranslation from '@/locales/de/translation.json';
import es419Translation from '@/locales/es-419/translation.json';
import frTranslation from '@/locales/fr/translation.json';
import idTranslation from '@/locales/id/translation.json';
import trTranslation from '@/locales/tr/translation.json';
import koTranslation from '@/locales/ko/translation.json';
import daTranslation from '@/locales/da/translation.json';
import nlTranslation from '@/locales/nl/translation.json';
import itTranslation from '@/locales/it/translation.json';
import msTranslation from '@/locales/ms/translation.json';
import ptBrTranslation from '@/locales/pt-BR/translation.json';
import zhTranslation from '@/locales/zh/translation.json';
import zhTwTranslation from '@/locales/zh-TW/translation.json';
import thTranslation from '@/locales/th/translation.json';
import plTranslation from '@/locales/pl/translation.json';
import bgTranslation from '@/locales/bg/translation.json';
import esEsTranslation from '@/locales/es-ES/translation.json';

const resources = {
  en: { translation: enTranslation },
  hu: { translation: huTranslation },
  de: { translation: deTranslation },
  'es-419': { translation: es419Translation },
  fr: { translation: frTranslation },
  id: { translation: idTranslation },
  tr: { translation: trTranslation },
  ko: { translation: koTranslation },
  da: { translation: daTranslation },
  nl: { translation: nlTranslation },
  it: { translation: itTranslation },
  ms: { translation: msTranslation },
  'pt-BR': { translation: ptBrTranslation },
  zh: { translation: zhTranslation },
  'zh-TW': { translation: zhTwTranslation },
  th: { translation: thTranslation },
  pl: { translation: plTranslation },
  bg: { translation: bgTranslation },
  'es-ES': { translation: esEsTranslation },
};

// Get initial language from URL or localStorage or default
const getInitialLanguage = (): string => {
  // In test environment, always use default locale
  if (typeof window === 'undefined' || import.meta.env.MODE === 'test') {
    return defaultLocale;
  }

  // Try to get from URL path (e.g., /en/sign-in)
  const pathParts = window.location.pathname.split('/');
  const urlLang = pathParts[1];
  if (locales.includes(urlLang)) {
    return urlLang;
  }

  // Fallback to localStorage or default
  return localStorage.getItem('language') || defaultLocale;
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: defaultLocale,
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
